import {
    updateField
} from 'vuex-map-fields';

export default {
    updateParticipantField(state, field) {
        updateField(state.participants, field);
    }
}